import { render, staticRenderFns } from "./allTree.vue?vue&type=template&id=5d04478c&scoped=true"
import script from "./allTree.vue?vue&type=script&lang=js"
export * from "./allTree.vue?vue&type=script&lang=js"
import style0 from "./allTree.vue?vue&type=style&index=0&id=5d04478c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d04478c",
  null
  
)

export default component.exports